import React from "react";
import { useIntl } from "@ai360/core/intl";

import { DialogBox, DialogBoxFooterType } from "~/core";
import { MessageDescriptor } from "react-intl";

export interface IDeleteConfDialog {
    deleteConfirmationTitle: MessageDescriptor;
    deleteConfirmationMessage: MessageDescriptor;
    onConfirmationClick?: (confirmation: boolean) => void;
    className?: string;
}
export const DeleteConfDialog = ({
    deleteConfirmationTitle,
    deleteConfirmationMessage,
    onConfirmationClick,
    className,
}: IDeleteConfDialog): JSX.Element => {
    const { formatMessage } = useIntl();
    return (
        <DialogBox
            unrestricted
            footerType={DialogBoxFooterType.YES_NO}
            isOpen={true}
            onAction={() => onConfirmationClick(true)}
            onClose={() => onConfirmationClick(false)}
            title={formatMessage(deleteConfirmationTitle)}
            className={className}
        >
            {formatMessage(deleteConfirmationMessage)}
        </DialogBox>
    );
};
